import React, { useEffect, useState } from 'react';
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

// Types
import { OnboardingWizardStep } from '../OnboardingWizard/types';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';
import OnboardingSlackAIWelcome from './partials/OnboardingSlackAIWelcome';
import OnboardingSlackAINextMeeting from './partials/OnboardingSlackAINextMeeting';
import OnboardingSlackAIGenerate from './partials/OnboardingSlackAIGenerate';
import OnboardingSlackAIGenerateManual from './partials/OnboardingSlackAIGenerateManual';
import OnboardingSlackKeepUsing from './partials/OnboardingSlackKeepUsing';
import OnboardingSlackAICreateAccount from './partials/OnboardingSlackAICreateAccount';
import Terminal from 'Dashboard/components/Onboarding/OnboardingWizard/Terminal/Terminal';
import Spinner from 'Shared/components/Spinner';

// Styles
import './OnboardingSlackAI.scss';

const STEPS_MAP = [
  OnboardingWizardStep.connectSlack,
  OnboardingWizardStep.nextMeeting,
  OnboardingWizardStep.generateAgenda,
  OnboardingWizardStep.letsGo,
];

const MANUAL_STEPS_MAP = [
  OnboardingWizardStep.connectSlack,
  OnboardingWizardStep.nextMeeting,
  OnboardingWizardStep.generateAgendaManual,
  OnboardingWizardStep.createAccount,
];

const OnboardingSlackAI = () => {
  const { step, flowType, userCreatedInMiddle } = useOnboardingState();

  const [currentSlide, setCurrentSlide] = useState(null);

  const stepsMap = userCreatedInMiddle ? STEPS_MAP : MANUAL_STEPS_MAP;

  useEffect(() => {
    setCurrentSlide(stepsMap.indexOf(step));
  }, [step, stepsMap]);

  useEffect(() => {
    (window as any).analytics.identify({ flowType });
    (window as any).analytics.track('Started Onboarding Step', { step }, { integrations: { Calixa: false } });
  }, [step]);

  const baseClassName = 'OnboardingSlackAI';

  if (step === OnboardingWizardStep.terminal) {
    return <Terminal />;
  }

  const getSlider = () => {
    if (!userCreatedInMiddle) {
      return (
        <Slider className={`${baseClassName}__carousel__slider`}>
          <Slide index={0} className={`${baseClassName}__carousel__slider__slide`}>
            <OnboardingSlackAIWelcome />
          </Slide>
          <Slide index={1} className={`${baseClassName}__carousel__slider__slide`}>
            <OnboardingSlackAINextMeeting />
          </Slide>
          <Slide index={2} className={`${baseClassName}__carousel__slider__slide`}>
            <OnboardingSlackAIGenerateManual />
          </Slide>
          <Slide index={3} className={`${baseClassName}__carousel__slider__slide`}>
            <OnboardingSlackAICreateAccount />
          </Slide>
        </Slider>
      );
    }

    return (
      <Slider className={`${baseClassName}__carousel__slider`}>
        <Slide index={0} className={`${baseClassName}__carousel__slider__slide`}>
          <OnboardingSlackAIWelcome />
        </Slide>
        <Slide index={1} className={`${baseClassName}__carousel__slider__slide`}>
          <OnboardingSlackAINextMeeting />
        </Slide>
        <Slide index={2} className={`${baseClassName}__carousel__slider__slide`}>
          <OnboardingSlackAIGenerate />
        </Slide>
        <Slide index={3} className={`${baseClassName}__carousel__slider__slide`}>
          <OnboardingSlackKeepUsing />
        </Slide>
      </Slider>
    );
  };

  return (
    <WpPageLayout className={baseClassName}>
      <WpPageBody>
        {currentSlide === null ? (
          <Spinner activeIf />
        ) : (
          <div className={`${baseClassName}__body`}>
            <div className={`${baseClassName}__body__main`}>
              <CarouselProvider
                currentSlide={currentSlide}
                naturalSlideWidth={100}
                naturalSlideHeight={125}
                totalSlides={stepsMap.length}
                dragEnabled={false}
                touchEnabled={false}
                disableKeyboard={true}
                isIntrinsicHeight
                className={`${baseClassName}__carousel`}
              >
                {getSlider()}
              </CarouselProvider>
            </div>
            <div className={`${baseClassName}__body__footer`}>
              <WpIllustration
                src={Illustrations.pi_logo_full_red_with_text}
                className={`${baseClassName}__body__footer__logo`}
                alt="Predictive Index Logo"
              />
            </div>
          </div>
        )}
      </WpPageBody>
    </WpPageLayout>
  );
};

export default OnboardingSlackAI;
